import React from 'react'
import CardDisplay from './CardDisplay'

const Projects = () => {
  return (
    <section id='projects' className="pt-36 bg-secondary">
        <h2 className="text-5xl font-text font-bold text-center ">Projects</h2>
        <CardDisplay/>
    </section>
  )
}

export default Projects